import PortfolioEntry from "./PortfolioEntry";
import { Grid, Typography, Box, Link, Stack } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function PortfolioList() {

    //TODO refactor to backend
    const entries = [
        {
            id: 1,
            link: 'https://hc-shows-calendar.com',
            title: 'HC Shows Calendar',
            description: 'Application for concert promoters to post upcoming concerts and for users to search for upcoming concerts by location.',
            currentTask: 'Improve the documentation on the Github repo...',
            techStack: ["React", "Golang", "Docker", "Google Cloud Platform"],
        },
        {
            id: 2,
            link: 'https://github.com/seancrim23/hc_archives_back',
            title: 'HC Archives',
            description: 'Archive application specifically for Hardcore Punk genre music. Users can add and edit information about their favorite bands records, members, location, etc.',
            currentTask: 'Work with frontend developer to refine a list of tasks to do...',
            techStack: ["Flask", "Docker"]
        },
        {
            id: 3,
            link: 'https://github.com/seancrim23/bellese_technology_challenge_inventory',
            title: 'Inventory Application',
            description: 'Simple inventory application for the tech challenge for Bellese in 2019. Was hired by Bellese after this challenge.',
            currentTask: 'Work with frontend developer to refine a list of tasks to do...',
            techStack: ["NodeJS", "React", "MongoDB"],
        },
        {
            id: 4,
            link: 'https://github.com/seancrim23/receipt_processor_challenge_fetch',
            title: 'Receipt Processor',
            description: 'Receipt processing application for the tech challenge for Fetch. Was not hired by Fetch after this challenge but am still proud of the solution.',
            currentTask: 'Work with frontend developer to refine a list of tasks to do...',
            techStack: ["Golang"],
        },
        {
            id: 5,
            link: 'https://github.com/seancrim23/zine_platform/',
            title: 'Zine Platform',
            description: 'Web platform for zine authors to upload their zines for reading and purchase by standard users.',
            currentTask: 'Brainstorm new features...',
            techStack: ["Golang"],
        },
        {
            id: 6,
            link: 'https://github.com/seancrim23/go_url_shortener_practice',
            title: 'URL Shortener',
            description: 'Users can provide a website URL to shorten and receive a custom URL in return. Creating as practice with Golang HTML templating rather than using my go to front end language React.',
            currentTask: 'Work with frontend developer to refine a list of tasks to do...',
            techStack: ["Golang"],
        },
        {
            id: 7,
            link: 'https://github.com/seancrim23/go_mailto_link_generator',
            title: 'Mailto Link Generator',
            description: 'Users provide an email address to mail to, a subject, and a body of an email and a URL is generated. Creating as practice with Golang HTML templating rather than using my go to front end language React.',
            currentTask: 'Work with frontend developer to refine a list of tasks to do...',
            techStack: ["Golang"],
        },
        {
            id: 8,
            link: 'https://github.com/seancrim23/sports_league_manager',
            title: 'Sports League Manager',
            description: 'Site in the design phase that will be used to fully manage any sporting league. Users can create leagues, add teams, track the games that happen between teams, etc.',
            currentTask: 'Work with frontend developer to refine a list of tasks to do...',
            techStack: ["Golang", "React"],
        },
    ]

    return (
        <>
            <Box sx={{ marginTop: '20px', marginRight: '-17px' }}>
                <Grid container spacing={1} sx={{ paddingRight: '5px', height: 'auto', maxHeight: '500px', overflow: 'hidden', overflowY: 'scroll' }}>
                    <Grid container item sx={{ marginTop: '-4px' }} xl={12}>
                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                            <Stack alignItems="center" direction="row" gap={1}>
                                <Link color="inherit" href="/">
                                    <ArrowBackIcon />
                                </Link>
                            </Stack>
                        </Grid>
                        <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                            <Typography sx={{ fontFamily: "Coolvetica", textAlign: 'center', paddingRight: { xs: '60px', sm: '100px', md: '100px', lg: '100px', xl: '100px' }, marginTop: '-6px' }} variant="h4">Projects</Typography>
                        </Grid>
                    </Grid>
                    {entries.map((entry) => (
                        <PortfolioEntry entry={entry} />
                    ))}
                </Grid>
            </Box>
        </>
    )
}

export default PortfolioList;